import { RouteObject } from 'react-router-dom';
import { Authorize } from '@/components';
import { BUSINESS_ROLE_GROUPS } from '@/components/security/AppRoles';
import { ErrorPage } from '@/pages/Layout/pages';
import Jobs from '../Jobs';

export const JobsRoutes: RouteObject[] = [
  {
    path: 'jobs',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.full}
        fallback={<ErrorPage code={403} />}
      >
        <Jobs />
      </Authorize>
    ),
  },
];
